enum PensionStatus {
  AKTIV = 'AKTIV',
  REINVESTERING = 'REINVESTERING',
  FROSSET = 'FROSSET',
  UNDEFINED = 'UNDEFINED',
}

export default PensionStatus;
